import { render, staticRenderFns } from "./EditTask.vue?vue&type=template&id=2c94c576&scoped=true"
import script from "./EditTask.vue?vue&type=script&lang=js"
export * from "./EditTask.vue?vue&type=script&lang=js"
import style0 from "./EditTask.vue?vue&type=style&index=0&id=2c94c576&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94c576",
  null
  
)

export default component.exports